// extracted by mini-css-extract-plugin
module.exports = {"productItem":"ProductItem_productItem__1gGJK","productDescription":"ProductItem_productDescription__3DdqP"};